import { useEffect } from 'react';

import { StackLayout } from '@leagueplatform/genesis-core';
import { useIntl } from '@leagueplatform/locales';
import { MainPageContainer } from '@leagueplatform/web-common-components';
import { SupplementalPremiumPaymentMasonrySection } from 'components/premium-payment/supplemental-premium-payment-masonry-section.component';
import { HeroSection } from 'components/hero-section/hero-section.component';
import { sendSupplementalPremiumPaymentScreenLoadedEvent } from 'utils/analytics-events';
import { useGoBack } from 'hooks/use-go-back.hook';

const SupplementalPremiumPaymentPage = () => {
  const { formatMessage } = useIntl();
  const { handleGoBack } = useGoBack();
  const title = formatMessage({ id: 'STR_SUPPLEMENTAL_PREMIUM_PAYMENT' });

  useEffect(() => {
    sendSupplementalPremiumPaymentScreenLoadedEvent();
  }, []);

  return (
    <MainPageContainer
      width="100%"
      css={{
        '.GDS-vertical-stack-layout': {
          width: '100%',
        },
      }}
    >
      <HeroSection title={title} height="120px" goBack={handleGoBack} />
      <StackLayout>
        <StackLayout
          css={{
            marginBottom: '$four',
          }}
        >
          <SupplementalPremiumPaymentMasonrySection />
        </StackLayout>
      </StackLayout>
    </MainPageContainer>
  );
};

export default SupplementalPremiumPaymentPage;
